export const PERMISSIONS = {
  PATIENT_ADD: "add_patient",
  PATIENT_CHANGE: "change_patient",
  PATIENT_VIEW: "view_patient",

  DEVICE_CHANGE: "change_device",

  HOSPITAL_CONFIG_CHANGE: "change_hospitalconfig",

  RESULT_DATA_VIEW: "view_resultdata",
  RESULT_DATA_ADD: "add_resultdata",
  RESULT_DATA_CHANGE: "change_resultdata",

  USER_ADD: "add_user",
  USER_VIEW: "view_user",
} as const;

export const PERMISSION_GROUPS = {
  RESULTS_VIEWER: [
    PERMISSIONS.PATIENT_VIEW,
    PERMISSIONS.RESULT_DATA_VIEW,
    PERMISSIONS.RESULT_DATA_ADD,
    PERMISSIONS.RESULT_DATA_CHANGE,
  ],
  MANAGE_PATIENT: [PERMISSIONS.PATIENT_VIEW, PERMISSIONS.PATIENT_ADD, PERMISSIONS.PATIENT_CHANGE],
  MANAGE_DEVICE: [PERMISSIONS.PATIENT_VIEW, PERMISSIONS.DEVICE_CHANGE],
  MANAGE_USER: [PERMISSIONS.USER_ADD, PERMISSIONS.USER_VIEW],
  MANAGE_HOSPITAL: [PERMISSIONS.HOSPITAL_CONFIG_CHANGE],
} as const;

export const ROLES = {
  PATIENT_MANAGER: {
    id: "patient_manager",
    name: "Patient Manager",
    description: "Users who are responsible for managing patients and prescribing treatment.",
    permissions: [
      ...PERMISSION_GROUPS.RESULTS_VIEWER,
      ...PERMISSION_GROUPS.MANAGE_PATIENT,
      ...PERMISSION_GROUPS.MANAGE_DEVICE,
    ],
  },
  PATIENT_VIEWER: {
    id: "patient_viewer",
    name: "Patient Viewer",
    description: "Users who can view patients and results history only.",
    permissions: [...PERMISSION_GROUPS.RESULTS_VIEWER],
  },
  RESTRICTED_USER: {
    id: "restricted_user",
    name: "Restricted User",
    description: "Users with limited access who can create new patients.",
    permissions: [...PERMISSION_GROUPS.MANAGE_PATIENT],
  },
  USER_MANAGER: {
    id: "user_manager",
    name: "User Manager",
    description: "Users with limited access who can create and manage dashboard users.",
    permissions: [...PERMISSION_GROUPS.MANAGE_USER],
  },
  DASHBOARD_ADMIN: {
    id: "",
    name: "Dashboard Admin",
    description: "Users with unlimited access to the dashboard",
    permissions: [
      ...PERMISSION_GROUPS.MANAGE_PATIENT,
      ...PERMISSION_GROUPS.MANAGE_USER,
      ...PERMISSION_GROUPS.MANAGE_HOSPITAL,
      ...PERMISSION_GROUPS.MANAGE_DEVICE,
      ...PERMISSION_GROUPS.RESULTS_VIEWER,
    ],
  },
} as const;

export type permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export type permissions = Readonly<Array<permission>>;

export type Role = {
  description: string;
  id: string;
  name: string;
  permissions: permissions;
};
